import { Component, Input, SimpleChanges } from '@angular/core'

import { TagColorsUtil } from './tag-colors.util'

@Component({
  standalone: false,
  selector: 'se-tag',
  templateUrl: './tag.component.html',
})
export class SeTagComponent {

  @Input('se-data-color') color: string
  @Input('se-data-value') value: string

  public colorClass: string = TagColorsUtil.COLOR_CLASS_PREFIX + TagColorsUtil.getDefaultColor()

  constructor() {
    // noop
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (TagColorsUtil.isValid(this.color)) {
      this.colorClass = TagColorsUtil.COLOR_CLASS_PREFIX + this.color
    }

  }

}